import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { Configuration } from "../constants/configuration";
import { QuattroB2C } from "../models/quattroB2C.model";
import { RequestServices } from "../services/request.service";
import { StorageService } from "../services/storage.service";

export class LogConsumoB2C {
    private subject = new Subject<any>();
    public constant: Configuration = new Configuration();
    public logConsumoIdB2C: string = "";
    public quattroB2C: QuattroB2C = new QuattroB2C();

    constructor(
        private router: Router,
        private requestService: RequestServices,
        private storageService: StorageService,
    ) { }

    logConsumo(datos?: any, carrusel?: number) {
        try {
            if (this.storageService.ifExist("logConsumoIDB2C")) {

                let productoIDEnc = "";
                if (this.storageService.ifExist("productoID")) {
                    productoIDEnc = this.storageService.getItem("productoID");
                }

                const log = JSON.parse(JSON.stringify({ "id": this.storageService.getItem("logConsumoIDB2C") }));
                // UPDATE PARA LOGCONSUMO
                let lconsumoB2C: LogConsumo = new LogConsumo();
                this.quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
                let paquete: string = "";
                switch (this.quattroB2C.paquete) {
                    case 1: // AMPLIA
                        paquete = "AMPLIA";
                        break;
                    case 2: // LIMITADA
                        paquete = "LIMITADA";
                        break;
                    case 3: // BÁSICA
                        paquete = "BÁSICA";
                        break;
                }

                lconsumoB2C.productoID = productoIDEnc;
                lconsumoB2C.correo = (this.quattroB2C?.prospecto?.correo) ? this.quattroB2C.prospecto?.correo : "";
                lconsumoB2C.nombre = (this.quattroB2C?.prospecto?.nombre) ? this.quattroB2C.prospecto?.nombre : "";
                lconsumoB2C.cp = (this.quattroB2C?.datosCotizacion?.cp) ? this.quattroB2C.datosCotizacion.cp : "";
                lconsumoB2C.modelo = (this.quattroB2C?.datosCotizacion?.modelo) ? this.quattroB2C.datosCotizacion.modelo : 0;
                lconsumoB2C.amis = (this.quattroB2C?.datosCotizacion?.amis) ? this.quattroB2C.datosCotizacion.amis : '';
                lconsumoB2C.descripcion = (this.quattroB2C?.datosCotizacion?.descripcion) ? this.quattroB2C.datosCotizacion.descripcion : '';
                lconsumoB2C.paquete = paquete;
                lconsumoB2C.origenID = (this.quattroB2C?.origen) ? this.quattroB2C.origen : 0;
                if (carrusel != undefined) {
                    lconsumoB2C.tipoCarrusel = carrusel;
                } else {
                    lconsumoB2C.tipoCarrusel = 0;
                }

                setTimeout(() => {
                    let data = {
                        "logConsumoIDEnc": log.id ? log.id : '',
                        "paso": this.getPaso(datos),
                        "masterJson": this.storageService.getItem("quattroB2C"),
                        "productoID": productoIDEnc,
                        "correo": lconsumoB2C.correo,
                        "nombre": lconsumoB2C.nombre,
                        "cp": lconsumoB2C.cp,
                        "modelo": lconsumoB2C.modelo,
                        "amis": lconsumoB2C.amis,
                        "descripcion": lconsumoB2C.descripcion,
                        "paquete": lconsumoB2C.paquete,
                        "origenID": lconsumoB2C.origenID,
                        "tipoCarrusel": lconsumoB2C.tipoCarrusel
                    }
                    this.requestService.postRequestAES({ projectName: new Configuration().API_B2C, apiName: 'b2c/publics/logConsumo/update', dataJSON: data }).subscribe(result => {
                        if (result.error) {
                            console.error("requestService.get", result.error);
                        } else if (result.ok == true) {


                        } else {
                            console.log("else.logConsumo.logConsumoUpdate", result);
                        }
                    });
                }, 400);
            } else { // INSERT PARA LOGCONSUMO 

                this.requestService.postRequestAES({ projectName: new Configuration().API_B2C, apiName: 'b2c/publics/logConsumo', dataJSON: datos }).subscribe(result => {
                    if (result.error) {
                        console.error("requestService.get", result.error);
                    } else if (result.ok == true) {
                        this.logConsumoIdB2C = result.result.logConsumoIDEnc;
                        this.storageService.setItem("logConsumoIDB2C", this.logConsumoIdB2C);
                        if (this.storageService.ifExist("quattroB2C")) {
                            this.quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
                            this.storageService.setItem("quattroB2C", JSON.stringify(this.quattroB2C));
                        }
                    } else {
                        console.log("else.logConsumo.logConsumoInsert", result);
                    }
                });
            }
        } catch (error) {
            this.subject.next(false)
            console.error("Error", error);
        }
    }

    getLogJSON(logConsumoIDB2C: string): Observable<any> {
        try {
            this.requestService.getRequest({ projectName: new Configuration().API_B2C, apiName: 'b2c/publics/logConsumo', params: [{ "logConsumoIDB2C": logConsumoIDB2C }] }).subscribe(result => {
                if (result.error) {
                    this.subject.next(result);
                    console.error("requestService.get", result.error);
                } else if (result.json) {
                    this.subject.next(result);
                } else {
                    this.subject.next(result);
                    console.log("else.logConsumo.getLogJSON", result);
                }
            });
        } catch (error) {
            this.subject.next(error);
            console.error(error);
        }
        return this.subject.asObservable();
    }

    getPaso(urlPaso?: number): number {

        let paso: number = 0;
        try {
            if (urlPaso && urlPaso !== 0) {
                paso = urlPaso;
            } else {
                switch (this.router.url) {
                    case '/autos/autos':
                        paso = 1;
                        break;
                    case '/cotizacion':
                        paso = 2;
                        break;
                    case '/datos-contratante':
                        paso = 3;
                        break;
                    case '/autos/datos-autos':
                        paso = 4;
                        break;
                    case '/datos-pago':
                        paso = 5;
                        break;
                    case '/datos-pago':
                        paso = 6;
                        break;
                    default:
                        break;
                }
            }
        } catch (error) {
            console.error("error", error);
        }
        return paso;
    }
}

export class LogConsumo {
    public productoID: string = "";
    public correo: string = "";
    public nombre: string = "";
    public cp: string = "";
    public modelo: number = 0;
    public amis: string = "";
    public descripcion: string = "";
    public paquete: string = "";
    public origenID: number = 0;
    public tipoCarrusel: number = 0;
}